import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsChefComponent } from './simple-icons-chef.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsChefComponent ],
    exports:      [ SimpleIconsChefComponent ],
    bootstrap:    []
})
export class SimpleIconsChefModule {}
